import useGraphQLPolling from 'apps/marketplace/utils/hooks/useGraphQLPolling'
import { useUserDetails } from 'utils/hooks'
import { IEscalatedIssuesQuery } from '../graphql/EscalatedIssues'
import { useEscalatedIssues } from './useEscalatedIssues'

const POLL_INTERVAL_MS = 20 * 60 * 1000 // 20 minutes

interface IUseNotificationsPolling {
  data: IEscalatedIssuesQuery['paginatedShipmentIssues']['nodes']
  issueCount: number
  error: string
  loading: boolean
  refetch: () => void
}

/**
 * Handles subscription to escalated issues that user either owns or is subscribed to
 */
export const useEscalatedIssuesPolling = (): IUseNotificationsPolling => {
  const { userDetails } = useUserDetails()
  const { startPolling, stopPolling, ...rest } = useEscalatedIssues({
    skip: !userDetails,
  })

  useGraphQLPolling({
    startPolling,
    stopPolling,
    pollInterval: POLL_INTERVAL_MS,
  })

  return {
    ...rest,
  }
}
